import axios from "axios";

export default {
	listContentAreas(ctx) {
		return axios.get("/v3/content_areas", { params: ctx });
	},

	getContentArea(id) {
		return axios.get(`/v3/content_area/${id}`);
	},

	saveContentArea(contentArea) {
		return axios.post("/v3/content_area", contentArea);
	},

	removeContentArea(id) {
		return axios.delete(`/v3/content_area/${id}`);
	}
};



// WEBPACK FOOTER //
// ./src/services/ContentAreaService.js